import { router, Stack } from 'expo-router';
import React from 'react';

import { PlusSignIcon } from '@hugeicons/core-free-icons';
import HeaderButton from '@molecules/HeaderButton';

import { headerOptionsCreator } from '@utils/screenOptions';

import HeaderDrawerButton from '@molecules/HeaderDrawerButton';

export default function Layout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={headerOptionsCreator(
          HeaderDrawerButton,
          <HeaderButton
            icon={PlusSignIcon}
            onPress={() => {
              router.navigate('/newMessage');
            }}
          />,
        )}
      />
      <Stack.Screen
        name="[conversationId]"
        options={headerOptionsCreator(
          <HeaderButton onPress={() => router.navigate('/inbox/connected')} />,
        )}
      />
    </Stack>
  );
}
